import { apolloClientInstance } from 'gatsby-theme-apollo';
import { gql } from '@apollo/client';

const getAuthorPosts = async ({ authorID }) => {
  if (!authorID) {
    console.error(`Unable to retireve posts for Author. Missing ID`);
  }
  const postQueryResult = await apolloClientInstance
    .query({
      query: gql`
        {
          posts(where: { author_eq: "${authorID}" }, sort:"createdAt:DESC") {
            title
            id
            publishedDate
            permalink
            createdAt
            games {
              name
              id
            }
          }
        }
      `
    })
    .then(result => {
      if (!result.data || !result.data || !result.data.posts) {
        return false;
      }
      const { posts } = result.data;
      return posts;
    })
    .catch(error => {
      console.error(`Somethin went wrong retrieving posts for author with ID ${authorID}`);
      console.error(error);
      return false;
    });

  return postQueryResult;
};

export { getAuthorPosts };
